import { useEffect, useState } from 'react'
import { useAuthContext } from 'contexts/auth.context'
import client from '../../services/client'
import { BaseData } from 'types/base.type'
import { Avatar } from '@mui/material'

export const FotoUsuario = () => {
  const { user } = useAuthContext()

  const [foto, setFoto] = useState<string | null>(null)

  useEffect(() => {
    ;(async () => {
      const url = user?.foto
      if (url) {
        await client
          .getBlob<BaseData<Blob>>(url)
          .then((response) => {
            const imageBlob = response.data
            if (imageBlob) {
              const imageObjectUrl = URL.createObjectURL(imageBlob)
              setFoto(imageObjectUrl)
            }
          })
          .catch((error) => console.error(error))
      }
    })()
  }, [user])

  return foto ? (
    <Avatar alt={user?.name} src={foto} sx={{ width: 32, height: 32 }} />
  ) : (
    <Avatar alt={user?.name} sx={{ width: 32, height: 32 }} />
  )
}
